import Axios from './Axios';

const API_URL = '/specialty/';

export const Speciality = {
  getList: () => Axios.get(API_URL + 'getList'),
  getOne: (params) => Axios.get(API_URL + 'get', params),
  add: (values) => Axios.post(API_URL + 'add-specialty', values),
  update: (values) => Axios.post(API_URL + 'update', values),
  delete: (params) => Axios.delete(API_URL + params),
  getSecondaryList: (id) => Axios.get(API_URL + `get-secondary/${id}`),
  getSecondaryOne: (params) => Axios.get(API_URL + 'get', params),
  addSecondary: (values) => Axios.post(API_URL + 'add-secondary', values),
  updateSecondary: (values) => Axios.post(API_URL + 'update-secondary', values),
  deleteSecondary: (params) => Axios.delete(API_URL + `delete-secondary/${params}`),
};
